@if (isInstitutionView) {
  <div class="contacts-header-with-button">
    <h5 class="blue-text title-text">Contacts</h5>
    <button mat-stroked-button color="primary" type="button" class="save-button" (click)="inviteContact()">
      <span>Invite Contact</span>
    </button>
  </div>
}
@if (contactsTableData() && contactsTableData().length > 0) {
  <div class="table-wrapper scrollable-table-data">
    <cfi-mat-table
      data-pw="additional-contacts-table"
      [allowExpand]="false"
      [columnDefinitions]="columns"
      [columnsToDisplayWithExpand]="displayedColumns"
      [data]="contactsTableData()"
      [displayedColumns]="displayedColumns"
      [class]="getTableClasses()"
      [paginated]="false"
      [showHeader]="true"
      [sortKey]="sortKey"
      [striped]="!isAdminView">
      <!-- Header Template -->
      <ng-template #headerTemplate let-column>
        <div class="school__contacts-cell">{{ column.header }}</div>
      </ng-template>

      <!-- Cell Template -->
      <ng-template #cellTemplate let-row let-column="column">
        @switch (column.name) {
          @case ('isPrimaryContact') {
            <div class="school__contacts-cell icon-cell">
              @if (isAdminView && row.isPrimaryContact) {
                <mat-icon class="check-icon" svgIcon="k12-circle-check"></mat-icon>
              }
              @if (!isAdminView) {
                <span>{{ row.isPrimaryContact ? 'Yes' : 'No' }}</span>
              }
            </div>
          }
          @case ('statusText') {
            <div class="school__contacts-cell">
              <span>{{ row.statusText }}</span>
            </div>
          }
          @case ('isHDMA') {
            <div class="school__contacts-cell icon-cell">
              @if (row.isHDMA && includeHdmaInList) {
                <mat-icon class="check-icon" svgIcon="k12-circle-check"></mat-icon>
              }
            </div>
          }
          @case ('actions') {
            @if (isAdminView) {
              <button
                aria-label="Promote to HDMA"
                class="contacts-action-button"
                mat-icon-button
                [attr.data-pw]="'contact-promote-' + row.id"
                (click)="onPromoteContact(row)"
                [disabled]="row?.statusId !== 2 || row?.isHDMA">
                <mat-icon>arrow_upward</mat-icon>
              </button>
              <!-- Todo: Remove this check when the institution view is ready to support messaging. -->
              @if (!isInstitutionView) {
                <button
                  aria-label="Message"
                  class="contacts-action-button"
                  mat-icon-button
                  [attr.data-pw]="'contact-message-' + row.id"
                  [disabled]="!row.accountId || row?.statusId === 3"
                  (click)="onMessageButtonClicked(row)">
                  <mat-icon class="message-icon" svgIcon="k12-messages"></mat-icon>
                </button>
              }
            }

            <button
              aria-label="Edit"
              class="contacts-action-button"
              mat-icon-button
              [attr.data-pw]="'contact-edit-' + row.id"
              [disabled]="row?.statusId === 3"
              (click)="editContact(row)">
              <mat-icon svgIcon="k12-edit"></mat-icon>
            </button>

            @if ((isSuperAdmin && isAdminView) || !isAdminView) {
              <span matTooltip="Deactivate User">
                <button
                  aria-label="Delete"
                  class="contacts-action-button"
                  mat-icon-button
                  [attr.data-pw]="'contact-delete-' + row.id"
                  [disabled]="row?.isHDMA || row?.statusId === 3"
                  (click)="deleteContact(row)">
                  <mat-icon svgIcon="k12-delete"></mat-icon>
                </button>
              </span>
            }
          }
          @default {
            <div>{{ row[column.name] }}</div>
          }
        }
      </ng-template>
    </cfi-mat-table>
  </div>
} @else {
  <div class="grid-col-12 grid-md:col-12 empty-panel">
    <span class="neutral-text">No Contacts Available</span>
  </div>
}
